/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetDownloadStatusQueryResponse,
  GetDownloadStatusPathParams,
  GetDownloadStatus404,
  GetDownloadStatus500,
} from '../types/GetDownloadStatus'

function getGetDownloadStatusUrl({
  request_id,
}: {
  request_id: GetDownloadStatusPathParams['request_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/downloads/${request_id}/status/` as const,
  }
  return res
}

/**
 * @description Get the status of a download request.
 * Args:
 * request: HTTP request
 * request_id: DownloadRequest ID
 * Returns:
 * Response with status information
 * @summary Get async download request status
 * {@link /api/v1/downloads/:request_id/status/}
 */
export async function getDownloadStatus(
  { request_id }: { request_id: GetDownloadStatusPathParams['request_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetDownloadStatusQueryResponse,
    ResponseErrorConfig<GetDownloadStatus404 | GetDownloadStatus500>,
    unknown
  >({
    method: 'GET',
    url: getGetDownloadStatusUrl({ request_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
